import React from 'react'
import { SVGProps } from 'react'

const HouseTypeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M8 1.2 1 7h1.6v7a.9.9 0 0 0 .9.9H6.4V10.4h3.2v4.5h2.9a.9.9 0 0 0 .9-.9V7H15L8 1.2Z" />
  </svg>
)
export default HouseTypeIcon
